import { Icon, Modal } from '@collegebacker/backer-ui/ui'
import { useRef, useEffect } from 'react'
import classnames from 'classnames'

export const BottomSheetTrigger = ({
  children,
  style,
  className,
  button,
  open,
  popupClassName,
}: {
  children: JSX.Element
  style?: {}
  className?: string
  button?: JSX.Element
  open?: boolean
  popupClassName?: string
}) => {
  const ref = useRef<any>(null)

  useEffect(() => {
    if (!open) {
      ref.current.close()
    }
  }, [open])

  return (
    <div style={style} className={className}>
      <Modal
        ref={ref}
        isBottomSheet={true}
        className={classnames(popupClassName)}
      >
        {children}
      </Modal>
      <button type="button" onClick={() => ref.current.open()}>
        {button || <Icon name="question" style={{ height: 20, width: 20 }} />}
      </button>
    </div>
  )
}
